import { useState } from "react";
import { useSettings } from "../hooks/useSettings"; 

const PrivacySettings = () => {
    const { updatePrivacy, loading, currentUser } = useSettings();

    const [privacyParams, setPrivacyParams] = useState({
        isPrivate: !!currentUser?.isPrivate,
        showActiveStatus: currentUser?.showActiveStatus !== undefined ? !!currentUser.showActiveStatus : true,
        showPublicKey: !!currentUser?.showPublicKey,
        messagePrivacy: currentUser?.messagePrivacy || "everyone"
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPrivacyParams(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updatePrivacy(privacyParams);
    };

    return (
        <div className="tab-content privacy-tab">
            <h2>Privacy Settings</h2>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>
                        Who can send you direct messages?
                    </label>

                    <select 
                        name="messagePrivacy" 
                        value={privacyParams.messagePrivacy} 
                        onChange={handleChange}
                        className="custom-select"
                    >
                        <option value="everyone">
                            Everyone
                        </option>

                        <option value="friends">
                            Friends Only
                        </option>

                        <option value="none">
                            No One
                        </option>
                    </select>
                </div>

                <div className="form-group toggle-group">
                    <div className="toggle-info">
                        <label>
                            Private Account
                        </label>

                        <p className="description">
                            Only approved followers can see your posts.
                        </p>
                    </div>

                    <label className="switch">
                        <input 
                            type="checkbox" 
                            name="isPrivate" 
                            checked={privacyParams.isPrivate} 
                            onChange={handleChange} 
                        />
                        <span className="slider round"></span>
                    </label>
                </div>

                <div className="form-group toggle-group">
                    <div className="toggle-info">
                        <label>
                            Show Active Status
                        </label>

                        <p className="description">
                            Let others see when you are online.
                        </p>
                    </div>
                    <label className="switch">
                        <input 
                            type="checkbox" 
                            name="showActiveStatus" 
                            checked={privacyParams.showActiveStatus} 
                            onChange={handleChange} 
                        />
                        <span className="slider round"></span>
                    </label>
                </div>

                <div className="form-group toggle-group">
                    <div className="toggle-info">
                        <label>
                            Display Public Key on Profile
                        </label>

                        <p className="description">
                            Allow others to see your wallet address on your profile page.
                        </p>
                    </div>

                    <label className="switch">
                        <input 
                            type="checkbox" 
                            name="showPublicKey" 
                            checked={privacyParams.showPublicKey} 
                            onChange={handleChange} 
                        />

                        <span className="slider round"></span>
                    </label>
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? "Saving..." : "Save Privacy Settings"}
                </button>
            </form>
        </div>
    );
};

export default PrivacySettings;